$(function() {
  var timer = null;
  $('.range').slider();
  if ($('span.label-scheduled').length > 0) {
    timer = setTimeout(function() {
      window.location.reload();
    }, 5000);
  } else {
    if (timer != null) {
      window.clearTimeout(timer);
    }
  }

  $('textarea.autoresize').each(function() {
    $(this).height(this.scrollHeight);
  });

  $('.datepicker').each(function() {
    var $this = $(this);
    var region = $this.data('regional') || 'en';
    $.datepicker.setDefaults($.datepicker.regional[region]);
    var date_format;
    if ($this.data('date-format') === '%d/%m/%Y') {
      date_format = 'dd/mm/yy';
    } else {
      date_format = 'mm/dd/yy';
    }
    var alt_field = $this.parents('.form-group').next('.form-group').find('input.datepicker_hidden');
    if ($this.data('no-min-date')) {
      $this.datepicker({ dateFormat: date_format });
    } else {
      $this.datepicker({ dateFormat: date_format, minDate: 0 });
    }
  });

  $('td.filters input.form-control').on('change', function() {
    $(this).parents('form').submit();
  });

  $('td.filters select').on('change', function() {
    $(this).parents('form').submit();
  });

  $('.clear-filters').click(function() {
    window.location = $(this).data('url');
  });

  $('#offer_different_delivery_address').on('change', function() {
    if ($(this).is(':checked')) {
      $('fieldset.delivery_address').show();
    } else {
      $('fieldset.delivery_address').hide();
    }
  });

  $('#alternative_i_nr_pocket_conf').on('change', function() {
    var val = $('#alternative_i_nr_pocket_conf option:selected').text();
    switch (val) {
      case '1':
        $('div.pc1').removeClass('hidden');
        $('div.pc2').addClass('hidden');
        $('div.pc3').addClass('hidden');
        $('div.pc4').addClass('hidden');
        $('div.column_matrix').removeClass('hidden');
        $('div.column_matrix div.details > div').each(function() {
          $(this).children('div:nth-of-type(2)').removeClass('hidden');
          $(this).children('div:nth-of-type(3)').addClass('hidden');
          $(this).children('div:nth-of-type(4)').addClass('hidden');
          $(this).children('div:nth-of-type(5)').addClass('hidden');
        });
        break;
      case '2':
        $('div.pc1').removeClass('hidden');
        $('div.pc2').removeClass('hidden');
        $('div.pc3').addClass('hidden');
        $('div.pc4').addClass('hidden');
        $('div.column_matrix').removeClass('hidden');
        $('div.column_matrix div.details > div').each(function() {
          $(this).children('div:nth-of-type(2)').removeClass('hidden');
          $(this).children('div:nth-of-type(3)').removeClass('hidden');
          $(this).children('div:nth-of-type(4)').addClass('hidden');
          $(this).children('div:nth-of-type(5)').addClass('hidden');
        });
        break;
      case '3':
        $('div.pc1').removeClass('hidden');
        $('div.pc2').removeClass('hidden');
        $('div.pc3').removeClass('hidden');
        $('div.pc4').addClass('hidden');
        $('div.column_matrix').removeClass('hidden');
        $('div.column_matrix div.details > div').each(function() {
          $(this).children('div:nth-of-type(2)').removeClass('hidden');
          $(this).children('div:nth-of-type(3)').removeClass('hidden');
          $(this).children('div:nth-of-type(4)').removeClass('hidden');
          $(this).children('div:nth-of-type(5)').addClass('hidden');
        });
        break;
      case '4':
        $('div.pc1').removeClass('hidden');
        $('div.pc2').removeClass('hidden');
        $('div.pc3').removeClass('hidden');
        $('div.pc4').removeClass('hidden');
        $('div.column_matrix').removeClass('hidden');
        $('div.column_matrix div.details > div').each(function() {
          $(this).children('div:nth-of-type(2)').removeClass('hidden');
          $(this).children('div:nth-of-type(3)').removeClass('hidden');
          $(this).children('div:nth-of-type(4)').removeClass('hidden');
          $(this).children('div:nth-of-type(5)').removeClass('hidden');
        });
        break;
      default:
        $('div.pc1, div.pc2, div.pc3, div.pc4, div.column_matrix').addClass('hidden');
    }
  });

  $('#alternative_i_nr_rows').on('change', function() {
    var val = $('#alternative_i_nr_rows option:selected').text();
    switch (val) {
      case '1':
        $('.column_matrix .details > div:nth-of-type(2)').removeClass('hidden');
        $('.column_matrix .details > div:nth-of-type(3), .column_matrix .details > div:nth-of-type(4), .column_matrix .details > div:nth-of-type(5), .column_matrix .details > div:nth-of-type(6), .column_matrix .details > div:nth-of-type(7)').addClass('hidden');
        break;
      case '2':
        $('.column_matrix .details > div:nth-of-type(2), .column_matrix .details > div:nth-of-type(3)').removeClass('hidden');
        $('.column_matrix .details > div:nth-of-type(4), .column_matrix .details > div:nth-of-type(5), .column_matrix .details > div:nth-of-type(6), .column_matrix .details > div:nth-of-type(7)').addClass('hidden');
        break;
      case '3':
        $('.column_matrix .details > div:nth-of-type(2), .column_matrix .details > div:nth-of-type(3), .column_matrix .details > div:nth-of-type(4)').removeClass('hidden');
        $('.column_matrix .details > div:nth-of-type(5), .column_matrix .details > div:nth-of-type(6), .column_matrix .details > div:nth-of-type(7)').addClass('hidden');
        break;
      case '4':
        $('.column_matrix .details > div:nth-of-type(2), .column_matrix .details > div:nth-of-type(3), .column_matrix .details > div:nth-of-type(4), .column_matrix .details > div:nth-of-type(5)').removeClass('hidden');
        $('.column_matrix .details > div:nth-of-type(6), .column_matrix .details > div:nth-of-type(7)').addClass('hidden');
        break;
      case '5':
        $('.column_matrix .details > div:nth-of-type(2), .column_matrix .details > div:nth-of-type(3), .column_matrix .details > div:nth-of-type(4), .column_matrix .details > div:nth-of-type(5), .column_matrix .details > div:nth-of-type(6)').removeClass('hidden');
        $('.column_matrix .details > div:nth-of-type(7)').addClass('hidden');
        break;
      case '6':
        $('.column_matrix .details > div:nth-of-type(2), .column_matrix .details > div:nth-of-type(3), .column_matrix .details > div:nth-of-type(4), .column_matrix .details > div:nth-of-type(5), .column_matrix .details > div:nth-of-type(6), .column_matrix .details > div:nth-of-type(7)').removeClass('hidden');
        break;
      default:
        $('.column_matrix .details > div:nth-of-type(2), .column_matrix .details > div:nth-of-type(3), .column_matrix .details > div:nth-of-type(4), .column_matrix .details > div:nth-of-type(5), .column_matrix .details > div:nth-of-type(6), .column_matrix .details > div:nth-of-type(7)').addClass('hidden');
    }
    inverted_rows(val);
  });

  function inverted_rows(nr_rows) {
    if (nr_rows <= 1) {
      $('#alternative_row1_inverted').prop('checked', false).attr('disabled', true);
    }
    if (nr_rows <= 2) {
      $('#alternative_row2_inverted').prop('checked', false).attr('disabled', true);
    }
    if (nr_rows <= 3) {
      $('#alternative_row3_inverted').prop('checked', false).attr('disabled', true);
    }
    if (nr_rows <= 4) {
      $('#alternative_row4_inverted').prop('checked', false).attr('disabled', true);
    }

    if (nr_rows >= 2) {
      $('#alternative_row1_inverted').attr('disabled', false);
    }
    if (nr_rows >= 3) {
      if ($('#alternative_row1_inverted').is(':checked')) {
        $('#alternative_row2_inverted').attr('disabled', false);
      } else {
        $('#alternative_row2_inverted').prop('checked', false).attr('disabled', true);
        $('#alternative_row3_inverted').prop('checked', false).attr('disabled', true);
      }
    }
    if (nr_rows >= 4) {
      if ($('#alternative_row2_inverted').is(':checked')) {
        $('#alternative_row3_inverted').attr('disabled', false);
      } else {
        $('#alternative_row3_inverted').prop('checked', false).attr('disabled', true);
      }
    }
    if (nr_rows >= 5) {
      if ($('#alternative_row3_inverted').is(':checked')) {
        $('#alternative_row4_inverted').attr('disabled', false);
      } else {
        $('#alternative_row4_inverted').prop('checked', false).attr('disabled', true);
      }
    }
  }

  function check_select_angle_yn(elem) {
    var val = elem.children('option:selected').text();
    if (val === 'N') {
      elem.parents('.angle_yn').nextAll('div').addClass('hidden');
      elem.parents('.angle_yn').parent().prev('div').children('div.rel-angle-yn').addClass('hidden');
    } else {
      elem.parents('.angle_yn').nextAll('div').removeClass('hidden');
      elem.parents('.angle_yn').parent().prev('div').children('div.rel-angle-yn').removeClass('hidden');
    }
  }

  function enforce_label_position_entry_and_height_stop_front(pf) {
    var pf_value = pf.val();
    var lp = pf.parents('.details').find('select.label_position');
    var hsf = pf.parents('.details').find('input.height_stop_f');
    var hsfp = hsf.parents('div.i_px_height_stop_f');
    var lhs = hsfp.parent().prev().find('div.label_hs');
    if (pf_value === 'Front Stop') {
      lp.val('FS');
      lp.children().each(function() {
        if ($(this).val() !== 'FS') {
          $(this).attr('disabled', true);
        }
      });
      lp.attr('readonly', true);
      hsfp.show();
      lhs.show();
      var hstop_front = ($('form.edit_alternative').data('lengthUnit') === 'imperial') ? 2.95 : 75;
      hsf.val(hstop_front);
    } else if (pf_value === 'Front Cover') {
      lp.val('FC');
      lp.children().each(function() {
        if ($(this).val() !== 'FC') {
          $(this).attr('disabled', true);
        }
      });
      lp.attr('readonly', true);
      hsfp.hide();
      lhs.hide();
    } else if (pf_value === 'Front Stop + Front Cover') {
      lp.val('FS + FC');
      lp.children().each(function() {
        if ($(this).val() !== 'FS') {
          $(this).attr('disabled', true);
        }
      });
      lp.attr('readonly', true);
      hsfp.show();
      lhs.show();
      var hstop_front = ($('form.edit_alternative').data('lengthUnit') === 'imperial') ? 2.95 : 75;
      hsf.val(hstop_front);
    } else if (pf_value === 'None') {
      if (lp.val() !== 'Top' && lp.val() !== 'Bottom') {
        lp.val('');
      }
      lp.children().each(function() {
        if (lp.val() !== 'Top' && lp.val() !== 'Bottom') {
          $(this).removeAttr('selected');
        }
        if ($(this).val() === 'Top' || $(this).val() === 'Bottom') {
          $(this).removeAttr('disabled');
        } else {
          $(this).attr('disabled', true);
        }
      });
      lp.removeAttr('readonly');
    }
  }

  function enforce_label_sizes(pf) {
    var first = pf.parents('.details').find('select.first_label');
    var second = pf.parents('.details').find('select.second_label');
    var divider = pf.parents('.details').find('select.pocket_inside').val();
    var height = pf.parents('.details').find('input.pocket_height').val();
    if ($('form.edit_alternative').data('lengthUnit') === 'imperial') {
      height *= 25.4;
    }
    var width = pf.parents('.details').find('input.pocket_width').val();
    if ($('form.edit_alternative').data('lengthUnit') === 'imperial') {
      width *= 25.4;
    }
    var divx = pf.parents('.details').find('div.labelx');
    var divy = pf.parents('.details').find('div.labely');

    if (pf.val() === 'Front Stop') {
      divx.hide();
      first.attr('readonly', true);
      divy.show();
      if (second.val() !== '0x0' && second.val() !== '100x50' && second.val() !== '130x75' && second.val() !== '150x105') {
        second.val('');
      }
      second.children().each(function() {
        if ($(this).val() !== '0x0' && $(this).val() !== '100x50' && $(this).val() !== '130x75' && $(this).val() !== '150x105') {
          $(this).attr('disabled', true);
        } else {
          $(this).removeAttr('disabled');
        }
      });
      second.attr('readonly', false);
    } else if (pf.val() === 'Front Cover') {
      divx.show();
      if (divider === 'Fixed Divider') {
        if (width > 470 && height > 220) {
          first.val('210x150');
        } else if (width > 350 && height > 175) {
          first.val('150x105');
        } else if (width > 310 && height > 145) {
          first.val('130x75');
        } else if (width > 250 && height > 120) {
          first.val('100x50');
        } else {
          first.val('0x0');
        }
      } else if (divider === 'None') {
        if (width > 235 && height > 220) {
          first.val('210x150');
        } else if (width > 175 && height > 175) {
          first.val('150x105');
        } else if (width > 155 && height > 145) {
          first.val('130x75');
        } else if (width > 125 && height > 120) {
          first.val('100x50');
        } else {
          first.val('0x0');
        }
      }
      first.attr('readonly', true);
      first.children().each(function() {
        $(this).attr('disabled', true);
      });
      second.val('');
      second.children().each(function() {
        if ($(this).val() !== '') {
          $(this).attr('disabled', true);
        }
      });
      second.attr('readonly', true);
      divy.hide();
    } else if (pf.val() === 'Front Stop + Front Cover') {
      divx.hide();
      first.attr('readonly', true);
      divy.show();
      if (divider === 'Fixed Divider') {
        if (width > 470 && height > 275) {
          second.val('210x150');
        } else if (width > 350 && height > 230) {
          second.val('150x105');
        } else if (width > 310 && height > 200) {
          second.val('130x75');
        } else if (width > 250 && height > 175) {
          second.val('100x50');
        } else {
          second.val('0x0');
        }
      } else if (divider === 'None') {
        if (width > 235 && height > 275) {
          second.val('210x150');
        } else if (width > 175 && height > 230) {
          second.val('150x105');
        } else if (width > 155 && height > 200) {
          second.val('130x75');
        } else if (width > 125 && height > 175) {
          second.val('100x50');
        } else {
          second.val('0x0');
        }
      }
      second.attr('readonly', true);
      second.children().each(function() {
        $(this).attr('disabled', true);
      });
    } else if (pf.val() === 'None') {
      divx.show();
      if (!first.hasClass('shadow')) {
        first.attr('readonly', true);
        if (divider === 'Fixed Divider') {
          if (210 < width / 2 - 25 && 150 < (height - 70) * 0.4) {
            first.val('210x150');
          } else if (150 < width / 2 - 25 && 105 < (height - 70) * 0.4) {
            first.val('150x105');
          } else if (130 < width / 2 - 25 && 75 < (height - 70) * 0.4) {
            first.val('130x75');
          } else if (100 < width / 2 - 25 && 50 < (height - 70) * 0.4) {
            first.val('100x50');
          } else {
            first.val('100x50');
          }
        } else if (divider === 'None') {
          if (210 < width - 25 && 150 < (height - 70) * 0.4) {
            first.val('210x150');
          } else if (150 < width - 25 && 105 < (height - 70) * 0.4) {
            first.val('150x105');
          } else if (130 < width - 25 && 75 < (height - 70) * 0.4) {
            first.val('130x75');
          } else if (100 < width - 25 && 50 < (height - 70) * 0.4) {
            first.val('100x50');
          } else {
            first.val('100x50');
          }
        }
      }
      second.val('');
      second.children().each(function() {
        $(this).attr('disabled', true);
      });
      second.attr('readonly', true);
      if (!first.hasClass('shadow')) {
        first.children().each(function() {
          $(this).attr('disabled', true);
        });
      }
      divy.hide();
    }
  }

  function check_height_stop_back(pb) {
    var pb_value = pb.val();
    var hsb = pb.parents('.details').find('input.height_stop_b');
    if (pb_value === 'Full Backstop') {
      hsb.val(0.0);
      hsb.attr('readonly', true);
    } else if (pb_value === 'Front Stop') {
      var fs_val = 75.0;
      if ($('form.edit_alternative').data('lengthUnit') === 'imperial') {
        fs_val /= 25.4;
      }
      hsb.val(Math.round(fs_val * 100) / 100);
      hsb.attr('readonly', true);
    } else {
      hsb.removeAttr('readonly');
    }
    if (hsb.hasClass("editable")) {
      hsb.removeAttr('readonly');
    }
  }

  function copy_height_stop(hs) {
    var pf = hs.parents('.details').find('select.pocket_front');
    enforce_label_sizes(pf);
  }

  function enforce_material_values(mv) {
    var mh = mv.parents('.details').find('select#alternative_i_mat_horizont, select#cad_alternative_i_mat_horizont');
    var mb = mv.parents('.details').find('select#alternative_i_mat_back, select#cad_alternative_i_mat_back');
    if (mv.val() === 'PC560G grey') {
      mh.val('PC560G grey');
      mb.val('PL05');
    } else if (mv.val() === 'PC560G blue') {
      mh.val('PC560G blue');
      mb.val('PL05');
    } else if (mv.val() === 'PL05') {
      mh.val('PL05');
      mb.val('PL05');
    } else if (mv.val() === 'PC560G FR') {
      mh.val('PC560G FR');
      mb.val('PC560G FR');
    }
  }

  function show_beam_step_fields(bt) {
    if (bt.val() === 'rectangle beam') {
      $('div.beam').addClass('hidden');
    } else {
      $('div.beam').removeClass('hidden');
    }
  }

  function check_pocket_divider(pw) {
    var inside = pw.parents('.details').find('select.pocket_inside');
    var max_width = 200;
    if ($('form.edit_alternative').data('lengthUnit') === 'imperial') {
      max_width /= 25.4;
    }
    if (parseFloat(pw.val(), 10) < max_width) {
      inside.val('None');
      inside.children().each(function() {
        if ($(this).val() !== 'None') {
          $(this).attr('disabled', true);
        }
      });
    } else {
      inside.children().each(function() {
        $(this).removeAttr('disabled');
      });
    }
  }

  $(document).on('change', 'select.pocket_inside', function() {
    enforce_label_sizes($(this).parents('.details').find('select.pocket_front'));
  });

  $(document).on('change', '.pocket_front', function() {
    enforce_label_position_entry_and_height_stop_front($(this));
    enforce_label_sizes($(this));
  });

  $(document).on('change', '.pocket_width', function() {
    enforce_label_sizes($(this).parents('.details').find('select.pocket_front'));
  });

  $(document).on('change', '.pocket_back', function() {
    check_height_stop_back($(this));
  });

  $(document).on('change', 'select.angle_yn', function() {
    check_select_angle_yn($(this));
  });

  $(document).on('change', 'input.pocket_height', function() {
    copy_height_stop($(this));
  });

  $(document).on('change', 'form#form-set-status-dead', function() {
    $('#set-dead-status-button').removeAttr('disabled');
  });

  $(document).on('change', 'select#alternative_i_mat_vert, select#cad_alternative_i_mat_vert', function() {
    enforce_material_values($(this));
  });

  $(document).on('change', '#alternative_i_beamtype, #cad_alternative_i_beamtype, #offer_rack_beam_type', function() {
    show_beam_step_fields($(this));
  });

  $(document).on('click', '#button-show-advanced-panel', function() {
    var cache_children = $('#title-panel-edit-trial').children();
    if ($(this).text() === $(this).data('show')) {
      $('form.edit_trial .panel-body .form-inputs > div:nth-of-type(26) ~ div').show();
      $(this).text($(this).data('hide'));
      $('#title-panel-edit-trial').text($('#title-panel-edit-trial').data('advanced')).append(cache_children);
    } else if ($(this).text() === $(this).data('hide')) {
      $('form.edit_trial .panel-body .form-inputs > div:nth-of-type(26) ~ div').hide();
      $(this).text($(this).data('show'));
      $('#title-panel-edit-trial').text($('#title-panel-edit-trial').data('standard')).append(cache_children);
    }
  });

  $(document).on('change', '.pocket_width', function() {
    check_pocket_divider($(this));
  });

  $('.pocket_front.editable_alternative').each(function() {
    enforce_label_position_entry_and_height_stop_front($(this));
  });

  $('.pocket_front').each(function() {
    enforce_label_sizes($(this));
  });

  $('select.angle_yn').each(function() {
    check_select_angle_yn($(this));
  });

  $('#alternative_i_beamtype, #offer_rack_beam_type, #cad_alternative_i_beamtype').each(function() {
    show_beam_step_fields($(this));
  });

  $('.pocket_width').each(function() {
    check_pocket_divider($(this));
  });

  $('.inverted-row').each(function() {
    inverted_rows($('#alternative_i_nr_rows option:selected').text());
  });

  $('.inverted-row').change(function() {
    inverted_rows($('#alternative_i_nr_rows option:selected').text());
  });

  $('a.print').click(function() {
    window.print();
  });

  $('#display_shade').each(function() {
    $('#shade').show();
  });

  $('#button-recompute').click(function() {
    $('#return_to').val(window.location.href.replace(window.location.hash, '') + '#column-matrix');
  });

  $(document).on('change', '.signed-offer #offer_signed_offer', function() {
    if ($(this)[0].files[0]) {
      $(this).closest('form').children('input[type=submit]').removeAttr('disabled');
    } else {
      $(this).closest('form').children('input[type=submit]').attr('disabled', true);
    }
  });

  $(document).on('show.bs.modal', '#accounts-list', function() {
    $('#accounts-list table').html('');
    // use a small, explicit {{key}} replacer instead of relying on _.templateSettings
    var account_template_str = $('#account_template').html();
    var escapeHtml = function(string) {
      return String(string).replace(/[&<>"'`]/g, function(s) {
        return ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
          '`': '&#96;'
        })[s];
      });
    };
    var account_template = function(data) {
      return account_template_str.replace(/\{\{\s*([\w-]+)\s*\}\}/g, function(_, key) {
        var v = data && data[key];
        return (v == null) ? '' : escapeHtml(v);
      });
    };
    $.ajax({
      method: 'GET',
      url: $('#accounts-list').data('accounts-url'),
      dataType: 'json',
      success: function(data, status, xhr) {
        for (var i = 0; i < data.length; i++) {
          var account = data[i];
          $("#accounts-table").append($(account_template(account)));
        }
      },
      error: function() {
        alert('Cannot get list of accounts.');
      }
    });
  });

  $(document).on('click', '#accounts-table a', function(evt) {
    evt.preventDefault();
    $("input#offer_account_id.hidden").val($(evt.target).data('account-id'));
    $("#accounts-list form").submit();
  });

  $(document).on('click', '#users-table a', function(evt) {
    evt.preventDefault();
    $("input#offer_creator_id.hidden").val($(evt.target).data('creator-id'));
    $("#users-list form").submit();
  });

  $(document).on('show.bs.modal', '#users-list', function() {
    $('#users-list table').html('');
    _.templateSettings = {
      interpolate: /\{\{(.+?)\}\}/g
    };
    var user_template = _.template($('#user_template').html());
    $.ajax({
      method: 'GET',
      url: $('#users-list').data('users-url'),
      dataType: 'json',
      success: function(data, status, xhr) {
        for (var i = 0; i < data.length; i++) {
          var user = data[i];
          $("#users-table").append($(user_template(user)));
        }
      },
      error: function() {
        alert('Cannot get list of users.');
      }
    });
  });

  $(document).on('click', '#users-table a', function(evt) {
    evt.preventDefault();
    $("input#account_rep_id").val($(evt.target).data('rep-id'));
    $("#users-list form").submit();
  });

  $('span.input-group-addon.help').on('click', function() {
    $('#help-modal div.modal-body').empty();
    $('#help-modal div.modal-body').append('<img class="limit-to-container" src="' + $(this).data('url') + '">');
  });

  $('#alternative_manual_override_crossbars').on('click', function() {
    if ($(this).is(':checked')) {
      $('#alternative_i_nr_crossbars').removeAttr('disabled');
    } else {
      $('#alternative_i_nr_crossbars').attr('disabled', true);
    }
  });

  $('#external-reassign-offer').on('click', function() {
    alert($(this).data('message'));
  });

  $('.dropdown-toggle').dropdown();

  $('button#clear-last-time-dlnd').click(function() {
    $('#offer_last_time_download').val('');
    $('#offer_ready_for_production').prop('checked', false);
    $('#clear_last_time_download').prop('value', 'true');
  });

  $('#offer_ready_for_production').on('change', function() {
    if ($(this).is(':checked')) {
      if (!($('#offer_i_cs_sales_order_number').val() !== '' &&
          $('#offer_i_cs_project_number').val() !== '' &&
          $('#offer_revision_number').val() !== '')) {
        $(this).prop('checked', false);
        alert($(this).data('message'));
      }
    }
  });

  $('form.edit_alternative.after-offered').each(function() {
    $('input:not(.editable-after-offered):not([type="hidden"])').attr('disabled', true);
    $('select:not(.editable-after-offered)').attr('disabled', true);
    $('textarea:not(.editable-after-offered)').attr('disabled', true);
  });

  if ($('form.edit_account div.override').length > 0) {
    var button = '<a class="btn btn-danger btn-xs">Override</a>';
    $('form.edit_account .override .override > div').each(function() {
      $(this).append(button);
    });
    $('form.edit_account .override .override-select > div').each(function() {
      $(this).append(button);
    });
    $('form.edit_account .override .override-boolean > div').each(function() {
      $(this).append(button);
    });
  }

  $('.override > div > a.btn').click(function() {
    var input = $(this).prev();
    var source = input.data('source');
    source = $('#' + source);
    input.val(source.val());
  });

  $('.override-select > div > a.btn').click(function() {
    var select = $(this).prev();
    var source = select.data('source');
    source = $('#' + source);
    select.find('option').filter(function() {
      return $(this).text() === source.val();
    }).attr('selected', true);
  });

  $('.override-boolean > div > a.btn').click(function() {
    var input = $(this).prev().find('input.boolean');
    var source = input.data('source');
    source = $('#' + source);
    if (source.val() === 'Yes') {
      input.prop('checked', true);
    } else {
      input.prop('checked', false);
    }
  });

  $('#account_override_pipedrive_status').on('click', function() {
    if ($(this).is(':checked')) {
      $('#account_pd_pipedrive_status').removeAttr('disabled');
    } else {
      $('#account_pd_pipedrive_status').attr('disabled', true);
    }
  });

  $('ul.dropdown-menu.as-links').on('click', function() {
    var translation = $(this).data('translation');
    $(this).parent().removeClass('open');
    $('#shade').show();
    $('body').append("<div id='alert-create-from-standard'>" + translation + "</div>");
  });

  $('#offer_allow_end_users').on('click', function() {
    if ($(this).is(':checked')) {
      $('.offer_eu_company_name, .offer_eu_company_contact, .offer_eu_company_email, .offer_eu_signee_name, .offer_eu_signee_email, .offer_eu_signee_phone, .offer_custom_currency, .offer_eu_send_date, .offer_eu_text_on_offer').removeClass('hidden');
      $('.multiple-tabs').parent().removeClass('hidden');
      $('.eu-logo-preview').removeClass('hidden');
      $('#end-user-prices-panel').removeClass('hidden');
    } else {
      $('.offer_eu_company_name, .offer_eu_company_contact, .offer_eu_company_email, .offer_eu_signee_name, .offer_eu_signee_email, .offer_eu_signee_phone, .offer_custom_currency, .offer_eu_text_on_offer, .offer_eu_send_date').addClass('hidden');
      $('.multiple-tabs').parent().addClass('hidden');
      $('.eu-logo-preview').addClass('hidden');
      $('#end-user-prices-panel').addClass('hidden');
    }
  });

  $('#offer_custom_currency').on('change', function() {
    $('.currency-symbol').text($(this).val());
  });

  $('[data-toggle="tooltip"]').tooltip();

  $('#pick_eu_signee').on('change', function() {
    var name = $(this).val();
    if (name) {
      var option = $(this).find('option:selected');
      var email = option.data('email');
      var phone = option.data('phone');
      $('#offer_eu_signee_name').val(name);
      $('#offer_eu_signee_email').val(email);
      $('#offer_eu_signee_phone').val(phone);
    }
  });

  if ($('form.edit_alternative').data('clear-rack-dimensions') === true) {
    $('.clear-value').val('');
  }

  function fill_parent(elem) {
    var parent = elem.parents('.panel');
    parent.find('.pocket_width').val(elem.data('width'));
    parent.find('.pocket_depth').val(elem.data('depth'));
    parent.find('.pocket_height').val(elem.data('height'));
    parent.find('.pockets_in_column').val(elem.data('pockets'));
    parent.find('.pocket_front').val(elem.data('front'));
    parent.find('.pocket_back').val(elem.data('back'));
    parent.find('.pocket_inside').val(elem.data('divider'));
    parent.find('.first_label').val(elem.data('labelx'));
    parent.find('.label_position').val(elem.data('label-position'));
    parent.find('.second_label').val(elem.data('labely'));
    parent.find('.angle_yn').val(elem.data('angle-yn'));
    parent.find('.angle_mm').val(elem.data('angle-to-back'));
    parent.find(".pocket_standard").val(elem.data("pocket-standard"));
  }

  $('.pocket-2 .fill-pocket a').on('click', function() {
    fill_parent($(this));
    $('#alternative_column_2_config').val($(this).data('standard-id'));
  });

  $('.pocket-3 .fill-pocket a').on('click', function() {
    fill_parent($(this));
    $('#alternative_column_3_config').val($(this).data('standard-id'));
  });

  $('.pocket-4 .fill-pocket a').on('click', function() {
    fill_parent($(this));
    $('#alternative_column_4_config').val($(this).data('standard-id'));
  });

  $('.chosen-select').chosen({
    allow_single_deselect: true,
    no_results_text: 'No results matched',
    width: '100%'
  });

  $(document).on('change', '#upload_offer_pictures', function() {
    if ($(this)[0].files[0]) {
      $(this).closest('form').children('input[type=submit]').removeAttr('disabled');
    } else {
      $(this).closest('form').children('input[type=submit]').attr('disabled', true);
    }
  });

  $(document).on('change', '#guess_signature_date_update', function() {
    $(this).parents("form").submit();
  });

  $("#eu_language a").on("click", function() {
    $("#offer_eu_language").val($(this).data("lang"));
  });
});
